import { render, staticRenderFns } from "./ListImageGroups.vue?vue&type=template&id=54c3815f&scoped=true"
import script from "./ListImageGroups.vue?vue&type=script&lang=js"
export * from "./ListImageGroups.vue?vue&type=script&lang=js"
import style0 from "./ListImageGroups.vue?vue&type=style&index=0&id=54c3815f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c3815f",
  null
  
)

export default component.exports